import React, { useState, useRef, useEffect } from 'react';
import './Carousel.css';


const Carousel = ({slidesData,vC}) => {
const VISIBLE_COUNT = 5;
const slideWidthPercent = 22; 
  const extended = [
    slidesData[slidesData.length - 1],
    ...slidesData,
    slidesData[0]
  ];

  const [index, setIndex] = useState(1);
  const [transitioning, setTransitioning] = useState(true);
  const slidesRef = useRef(null);

  const goNext = () => setIndex(i => i + 1);
  const goPrev = () => setIndex(i => i - 1);

  useEffect(() => {
    const node = slidesRef.current;
    const handleTransitionEnd = () => {
      setTransitioning(false);
      if (index === extended.length-1)      setIndex(1);
      else if (index === 0)                   setIndex(extended.length - 2);
    };
    node.addEventListener('transitionend', handleTransitionEnd);
    return () => node.removeEventListener('transitionend', handleTransitionEnd);
  }, [index, extended.length]);

  useEffect(() => {
    if (!transitioning) {
      const el = slidesRef.current;
      el.style.transition = 'none';
      el.style.transform  = `translateX(-${index * slideWidthPercent}%)`;
      el.getBoundingClientRect();
      el.style.transition = '';
      setTransitioning(true);
    }
  }, [transitioning, index]);

  return (
    <div className="carousel-container">
      <button onClick={goPrev} className="nav-arrow left-arrow">‹</button>
      <div className="slides-wrapper">
        <div
          ref={slidesRef}
          className="slides"
          style={{
            width: `${(extended.length * 100) / VISIBLE_COUNT}%`,
            transform: `translateX(-${index * slideWidthPercent}%)`
          }}
        >
          {extended.map((slide, idx) => (
            <div key={idx} className="slide" style={{ flex: `0 0 ${slideWidthPercent}%`}}>
              <img style={{height:vC===4?"450px":"300px"}} src={slide.imageUrl} alt={slide.title} />
              <h3>{slide.title}</h3>
            </div>
          ))}
        </div>
      </div>
      <button onClick={goNext} className="nav-arrow right-arrow">›</button>
      <div className="carousel-indicators">
        {slidesData.map((_, idx) => (
          <div
            key={idx}
            className={`indicator ${
              idx === ((index - 1 + slidesData.length) % slidesData.length) ? 'active' : ''
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
